export const resetStoreAction = () => dispatch => {
  dispatch({ type: 'RESET_STORE' })
}
